import { faBeer, faPeopleGroup, faFootball } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './VenueType.scoped.scss';

const VenueType = ({filters, handleFilterChange}) => {
    const venueTypeOptions = [
        "stadium",
        "team",
        "sports"
    ];
    const venueDisplayMapping = {
        stadium: 'Stadium',
        team: 'Team Bar',
        sports: 'Sports Bar'
    };

    return (
        <div className='tiles venues'>
            {venueTypeOptions.map(venue => (
                <div className='input-container'> 
                    <input 
                        className='check-button'
                        type="checkbox" 
                        checked={filters.venueType[venue]} 
                        onChange={() => handleFilterChange('venueType', venue)} 
                    /> 
                    <div className="check-tile">
 
                        <label key={venue} className={ "check-tile-label " + ( venue || "") }>{venueDisplayMapping[venue]}</label>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default VenueType;